/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import {useStaticQuery, graphql} from "gatsby"
import 'antd/dist/antd.min.css';
import "fontsource-euphoria-script";
import "fontsource-quicksand";
import "fontsource-lato";

import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import "./prism-okaidia-modified.css"

const Layout = ({children}) => {
    // query to get the site title stored in gatsby-config.js
    const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
    `)

    return (
        <>
            <Header siteTitle={data.site.siteMetadata.title}/>
            <div className={'blogMain'}>
                <main>{children}</main>
            </div>
            <Footer siteTitle={data.site.siteMetadata.title}/>
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
